/**
 * Fixed list of 100 UN-designated country names for the User Information
 * form's country field. Names and coverage match the UN M49 country list
 * provided for this dashboard — do not edit wording/spelling.
 */
export const COUNTRIES = [
    'Albania',
    'Algeria',
    'Angola',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahrain',
    'Bangladesh',
    'Belgium',
    'Brazil',
    'Bulgaria',
    'Cambodia',
    'Canada',
    'Chile',
    'China',
    'Colombia',
    'Costa Rica',
    'Croatia',
    "Côte d'Ivoire",
    'Cyprus',
    'Czechia',
    'Denmark',
    'Dominican Republic (the)',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Estonia',
    'Ethiopia',
    'Finland',
    'France',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Kazakhstan',
    'Kenya',
    'Korea (the Republic of)',
    'Kyrgyzstan',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malaysia',
    'Malta',
    'Mexico',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Nepal',
    'Netherlands (Kingdom of the)',
    'New Zealand',
    'Nigeria',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Peru',
    'Philippines (the)',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russian Federation (the)',
    'Rwanda',
    'Saudi Arabia',
    'Serbia',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'South Africa',
    'Spain',
    'Sri Lanka',
    'Sweden',
    'Switzerland',
    'Taiwan (Province of China)',
    'Tajikistan',
    'Tanzania, the United Republic of',
    'Thailand',
    'Türkiye',
    'Uganda',
    'United Arab Emirates (the)',
    'United Kingdom of Great Britain and Northern Ireland (the)',
    'United States of America (the)',
    'Uruguay',
    'Uzbekistan',
    'Venezuela (Bolivarian Republic of)',
    'Viet Nam',
];
